// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"toolbox__wrapper___3ZdHV","list":"toolbox__list___2bxyZ","collapsed":"toolbox__collapsed___2SZaz","titlebar":"toolbox__titlebar___JL-Cb","body":"toolbox__body___NmiIi","plus-button":"toolbox__plus-button___kVYqu","plusButton":"toolbox__plus-button___kVYqu"};


//////////////////
// WEBPACK FOOTER
// ../stylesheet/css/header-builder/toolbox.css
// module id = 799
// module chunks = 0